import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonMaterialModule } from '@nrwl/common-material';
import { CommonLibModule } from '@nrwl/common-lib';
import { DataSourceManagementModule } from '@nrwl/datasource-management';
import { BaseSetupService } from './base-setup.service';
import { TestSetupTabsComponent } from './test-setup-tabs/test-setup.tabs.component';
import { TestStatusDialogComponent } from './test-status-dialog/test-status-dialog.component';
import { CollectorApiService } from './service/single-test-api/collector-api.service';
import { ControllerApiService } from './service/single-test-api/controller-api.service';
import { ViaviTabulatorModule } from '@nrwl/viavi-tabulator';
import { MultiSitePickerComponent } from './multi-site-picker/multisite-picker.component';
import { DeviceTableComponent } from './multi-site-picker/device-table/device-table.component';
import { SiteTableComponent } from './multi-site-picker/site-table/site-table.component';
import { CartItemsPickerComponent } from './cart-items-picker/cart-items-picker.component';
import { CartListTableComponent } from './cart-items-picker/cart-list-table/cart-list-table.component';
import { CartPickerTableComponent } from './cart-items-picker/cart-picker-table/cart-picker-table.component';
import { TestIdentityComponent } from './components/test-identity/test-identity.component';
import { AgentPickerComponent } from './components/agent-picker/agent-picker.component';
import { AgentListComponent } from './components/agent-list/agent-list.component';
import { TemplateService } from './template.service';
import { SaveTemplateComponent } from './components/save-template/save-template.component';
import { MultiAgentPickerComponent } from './multi-agent-picker/multi-agent-picker.component';
@NgModule({
  imports: [
    CommonModule,
    CommonLibModule,
    FormsModule,
    ReactiveFormsModule,
    CommonMaterialModule,
    ViaviTabulatorModule,
    DataSourceManagementModule
  ],
  declarations: [
    TestSetupTabsComponent,
    TestStatusDialogComponent,
    MultiSitePickerComponent,
    DeviceTableComponent,
    SiteTableComponent,
    CartItemsPickerComponent,
    CartListTableComponent,
    CartPickerTableComponent,
    TestIdentityComponent,
    AgentPickerComponent,
    AgentListComponent,
    SaveTemplateComponent,
    MultiAgentPickerComponent
  ],
  providers: [BaseSetupService, CollectorApiService, ControllerApiService, TemplateService],
  exports: [
    TestSetupTabsComponent,
    TestStatusDialogComponent,
    CartItemsPickerComponent,
    TestIdentityComponent,
    AgentPickerComponent,
    SaveTemplateComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TestSetupModule {}
